export function validateCString(str, min, max) {
  const pattern = `^[a-zA-Z0-9\\u4e00-\\u9fa5]{${min},${max}}$`;
  const regex = new RegExp(pattern);
  if (!regex.test(str)) {
    return false;
  }
  return true;
}

export function validateUnitString(str, min, max) {
  const pattern = `^[a-zA-Z0-9%\\-/\\u4e00-\\u9fa5]{${min},${max}}(°C)?$`;
  const regex = new RegExp(pattern);
  return regex.test(str);
}

export function validateMqttTopic(topic) {
  const pattern = /^[a-zA-Z0-9/_{}$]+$/;
  const regex = new RegExp(pattern);
  return regex.test(topic);
}

export function validateString(str, min, max) {
  const pattern = `^[a-zA-Z0-9]{${min},${max}}$`;
  const regex = new RegExp(pattern);
  if (!regex.test(str)) {
    return false;
  }
  return true;
}

export function validateCode(str) {
  const pattern = /^[a-zA-Z0-9]{8}-\d$/;
  const regex = new RegExp(pattern);
  if (!regex.test(str)) {
    return false;
  }
  return true;
}

export function validateName(str, min, max) {
  const pattern = `^(?=.*[a-zA-Z0-9\u4e00-\u9fff])[a-zA-Z0-9\u4e00-\u9fff &-]{${min},${max}}$`;
  const regex = new RegExp(pattern);
  return regex.test(str);
}

export function validatePath(path, min, max) {
  const pattern = `^[a-zA-Z0-9_/.\\\\]{${min},${max}}$`;
  const regex = new RegExp(pattern);
  if (!regex.test(path) || path.length < 1) {
    return false;
  }
  return true;
}

export function validatePassword(str) {
  const regex = /^[a-zA-Z0-9@]{8,16}$/;
  if (!regex.test(str)) {
    return false;
  }
  return true;
}

export function validateNumber(str, min, max) {
  const pattern = `^[0-9]{${min},${max}}$`;
  const regex = new RegExp(pattern);
  return regex.test(str);
}

export function validateMACAddress(mac) {
  const pattern = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;
  const regex = new RegExp(pattern);
  return regex.test(mac);
}

export function validateVersionNumber(version) {
  const pattern = /^\d+\.\d+\.\d+$/;
  const regex = new RegExp(pattern);
  return regex.test(version);
}

export function getPages() {
  const json = localStorage.getItem('user');
  const user = JSON.parse(json);
  if (user.pages) {
    const pages = user.pages.trim().split(',');
    return pages;
  }
  return [];
}

export function checkPages(str) {
  const array = getPages();
  if (array.includes(str)) {
    return true;
  }
  return false;
}

export function convertGMT0toGMT8(timeGMT0) {
  const date = new Date(`${timeGMT0}Z`);
  const timeTaipei = date.toLocaleString('zh-TW', {
    timeZone: 'Asia/Taipei',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).replace(/\//g, '-').replace(', ', ' ');

  return timeTaipei;
}
